import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tagLink']

  connect() {
    this.values = [];
  }

  onFilterUpdated(event) {
    // console.log('onFilterUpdated TAGS', {event})
    this.values = event.detail.values
    this.updateSelectedTags()
  }

  updateSelectedTags() {
    const tagLinks = this.tagLinkTargets;
    // console.log('updateSelectedTags TAGS', {tagLinks})
    tagLinks.forEach(tag => {
      const directionId = tag.dataset.directionId
      if (this.values.includes(directionId)) {
        tag.classList.add('selected')
      } else {
        tag.classList.remove('selected')
      }
    })
  }

  onToggleDropdown(event) {
    const element = event.currentTarget;
    const directionId = element.dataset.directionId;
    // console.log('onToggleDropdown TAGS', {event, element, directionId})
    if (element.classList.contains('selected')) {
      // Element has 'selected' class, so remove it
      this.values = this.values.filter(value => value !== directionId);
    } else {
      // Element does not have 'selected' class, so add it
      this.values.push(directionId);
    }
    
    this.dispatch('filter-applied', { detail: { name: 'direction_ids', values: this.values }, bubbles: true});
  }
}
